import React, { FC, useEffect, useState } from 'react';
import styles from './scorebadge.module.sass';
import cx from 'classnames';
import { Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const ScoreBadge = ({
  score,
  scoreTextRecolor,
  scoreTextDescription,
  scoreProgressRecolor,
  boxOpacity,
  boxBordered,
  loading,
  ...props
}) => {
  const { Title, Text } = Typography;
  const [scoreColorClass, setScoreColorClass] = useState('');
  const [textRecolor, setTextRecolor] = useState(false);
  const [textDescription, setTextDescription] = useState(undefined);
  const [progressRecolor, setProgressRecolor] = useState(false);
  const [boxBackgroundOpacity, setBoxBackgroundOpacity] = useState(undefined);
  const [boxBorder, setBoxBorder] = useState(false);

  useEffect(() => {
    let colorClass = styles.success;
    if (score > 40) {
      colorClass = styles.error;
    } else if (score >= 25) {
      colorClass = styles.warning;
    }

    setScoreColorClass(colorClass);
    setTextRecolor(scoreTextRecolor);
    setTextDescription(scoreTextDescription);
    setProgressRecolor(scoreProgressRecolor);
    setBoxBackgroundOpacity(boxOpacity);
    setBoxBorder(boxBordered);
  }, [score]);

  return (
    <div
      className={cx(
        styles.score_badge,
        scoreColorClass,
        boxBorder ? styles.bordered : null,
      )}
    >
      <div className={styles.content}>
        <Title level={4} className={textRecolor ? scoreColorClass : null}>
          {loading ? <Spin indicator={<LoadingOutlined spin />}></Spin> : score}
        </Title>
        {textDescription ? (
          <Text className={textRecolor ? scoreColorClass : null}>
            {textDescription}
          </Text>
        ) : null}
        <div
          className={cx(
            styles.progress,
            progressRecolor ? scoreColorClass : null,
          )}
          style={{ width: `${score}%` }}
        />
      </div>

      <div
        className={cx(styles.background, scoreColorClass)}
        style={{ opacity: boxBackgroundOpacity }}
      ></div>
    </div>
  );
};

export default ScoreBadge;
